// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"7206c34d","45":"b9bd3715"}[chunkId] + ".chunk.js";
};